import commonFrontEndVars from '~common/front-end-vars';
import frontEndVarsGen from '~/front-end-vars-gen';
const spacingL = '50px';
export default Object.assign({}, commonFrontEndVars, frontEndVarsGen, {
    'popup-min-margin': '20px',
    'left-block-width': '250px',
    'spacing-l': spacingL,
    'page-spacing': spacingL,
});



// WEBPACK FOOTER //
// ./makosh/assets/front-end-vars.js